/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2020 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { consentreference } from '../domain/consentreference';
import { connectionparameters } from 'projects/icemedx-lib/src/models/messages/connectionparameters';
import { observation } from 'projects/icemedx-lib/src/models/ehr/subs/observation';
import { managementguideline } from 'projects/icemedx-lib/src/models/ehr/subs/managementguideline';
import { externaldata } from 'projects/icemedx-lib/src/models/ehr/externaldata';

export class telehealthtrial extends IceEntity {
  Campaign: string = "";
  Background: string = "";
  Specialty: string = "";
  Title: string = "";
  Firstname: string = "";
  Lastname: string = "";
  Phone: string = "";
  Country: string = "";
  Email: string = "";
  Credentials: string = "";
  MessageKey: string = "";
}
